import React from "react";
import TabTemplate from "../../../_shoru_shared_library/template/TabTemplate";
import recallsRouter from "./recallsRouter";

function RecallsTab(props) {

  return (
    <TabTemplate 
      router={recallsRouter}
      passData={props.passData}
    />
  )

}

export default RecallsTab;